import {
  Avatar,
  Box,
  Divider,
  Grid,
  Paper,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Typography,
  Button,
  Menu,
  MenuItem,
} from "@mui/material";
import React, { useState } from "react";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import CancelTwoToneIcon from "@mui/icons-material/CancelTwoTone";
import useFetchObjects from "../../../../api/useFetchObjects";
import { useAuth } from "../../../../context";
import useUpdate from "../../../../api/useUpdate";
import SkeletonLoading from "./loading/SkeletonLoading";
import { useTranslation } from "react-i18next";

const getButtonColor = (status) => {
  switch (status) {
    case 1:
      return "#FFC107";
    case 2:
      return "#4CAF50";
    case 3:
      return "#F44336";
    default:
      return "#a7e2f9";
  }
};

const TestsToBeDone = () => {
  const { t } = useTranslation();
  const XrayStatus = {
    1: t("x_ray.pending"),
    2: t("x_ray.completed"),
    3: t("x_ray.cancelled"),
  };
  const [value, setValue] = useState(0);
  const auth = useAuth();
  const token = auth?.user?.token;

  const status = value === 0 ? 1 : value === 1 ? 2 : 3;

  const { data, isLoading, isError, error } = useFetchObjects(
    ["patient-xray", status],
    `patient-xray/?status=${status}`,
    token
  );

  const { handleUpdate } = useUpdate("patient-xray", token);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selectedXray, setSelectedXray] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event, xray) => {
    setAnchorEl(event.currentTarget);
    setSelectedXray(xray);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setSelectedXray(null);
  };

  const handleStatusChange = (newStatus) => {
    const formData = new FormData();
    formData.append("status", newStatus);
    handleUpdate(selectedXray.id, formData);
    handleClose();
  };

  const buttonStyle = {
    border: "2px solid",
    borderRadius: "0.5em",
    color: "#a7e2f9",
    margin: "1em",
  };
  const tablecellStyle = {
    fontSize: "13px",
  };

  return (
    <Grid item xs={12}>
      {isLoading ? (
        <SkeletonLoading />
      ) : (
        <Paper sx={{ boxShadow: "0px 0px 0px" }}>
          <Grid container padding={"10px"}>
            <Grid item>
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="scrollable force tabs example"
              >
                <Tab
                  sx={{ textTransform: "capitalize" }}
                  label={t("x_ray.testToBeDone")}
                />
                <Tab
                  sx={{ textTransform: "capitalize" }}
                  label={t("x_ray.done")}
                />
                <Tab
                  sx={{ textTransform: "capitalize" }}
                  label={t("x_ray.canceled")}
                />
              </Tabs>
            </Grid>
            <Divider sx={{ mt: 2, width: "100%" }} />

            {isError && (
              <Typography>
                {t("x_ray.error")}: {error.message}
              </Typography>
            )}
            {data && (
              <TableContainer sx={{ mt: 2 }}>
                <Table sx={{ minWidth: "100%" }} aria-label="simple table">
                  <TableHead style={{ backgroundColor: "#f2f2f2" }}>
                    <TableRow>
                      <TableCell align="center" style={tablecellStyle}>
                        {t("x_ray.time")}
                      </TableCell>
                      <TableCell align="center" style={tablecellStyle}>
                        {t("x_ray.date")}
                      </TableCell>
                      <TableCell align="center" style={tablecellStyle}>
                        {t("x_ray.patientName")}
                      </TableCell>
                      <TableCell align="center" style={tablecellStyle}>
                        {t("x_ray.doctor")}
                      </TableCell>
                      <TableCell align="center" style={tablecellStyle}>
                        {t("x_ray.testType")}
                      </TableCell>
                      <TableCell align="center" style={tablecellStyle}>
                        {t("x_ray.amount")}
                      </TableCell>
                      <TableCell align="center" style={tablecellStyle}>
                        {t("x_ray.paymentStatus")}
                      </TableCell>
                      <TableCell align="center" style={tablecellStyle}>
                        {t("x_ray.status")}
                      </TableCell>
                      <TableCell align="center" style={tablecellStyle}>
                        {t("x_ray.actions")}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody sx={{ bgcolor: "#ccfcfc" }}>
                    {data.map((item, i) => (
                      <TableRow
                        key={i}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell
                          align="center"
                          style={tablecellStyle}
                          component="th"
                          scope="row"
                        >
                          {item.date}
                        </TableCell>
                        <TableCell align="center" style={tablecellStyle}>
                          {item.date}
                        </TableCell>
                        <TableCell
                          align="center"
                          style={tablecellStyle}
                          component="th"
                        >
                          {item.patient_display}
                        </TableCell>
                        <TableCell align="center" style={tablecellStyle}>
                          {item.assigned_doctor_display}
                        </TableCell>
                        <TableCell align="center" style={tablecellStyle}>
                          {item.xray_type_display}
                        </TableCell>
                        <TableCell align="center" style={tablecellStyle}>
                          {item.total_amount} ؋
                        </TableCell>
                        {/* New Column */}
                        <TableCell align="center" style={tablecellStyle}>
                          {item.is_paid ? (
                            <Typography color="green" style={tablecellStyle}>
                              {t("x_ray.paid")}
                            </Typography>
                          ) : (
                            <Typography color="red" style={tablecellStyle}>
                              {t("x_ray.unpaid")}
                            </Typography>
                          )}
                        </TableCell>
                        <TableCell align="center" style={tablecellStyle}>
                          <Typography
                            sx={{
                              fontWeight: "bold",
                              fontSize: "12px",
                              color: getButtonColor(item.status),
                            }}
                          >
                            {XrayStatus[item.status]}
                          </Typography>
                        </TableCell>
                        <TableCell align="center" style={tablecellStyle}>
                          {item.status === 1 ? (
                            <Button
                              id="demo-positioned-button"
                              aria-controls={
                                open ? "demo-positioned-menu" : undefined
                              }
                              aria-haspopup="true"
                              aria-expanded={open ? "true" : undefined}
                              onClick={(event) => handleClick(event, item)}
                            >
                              <MoreHorizIcon />
                            </Button>
                          ) : (
                            <Typography style={tablecellStyle}>
                              {t("x_ray.noFurtherActions")}
                            </Typography>
                          )}
                          <Menu
                            id="demo-positioned-menu"
                            aria-labelledby="demo-positioned-button"
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleClose}
                            anchorOrigin={{
                              vertical: "top",
                              horizontal: "left",
                            }}
                            transformOrigin={{
                              vertical: "top",
                              horizontal: "left",
                            }}
                            PaperProps={{
                              sx: {
                                boxShadow: "0px 20px 10px rgba(0, 0, 0, 0.02)",
                                "&:before": { boxShadow: "none" },
                                border: "1px solid lightgray",
                                borderRadius: "1em",
                                padding: "10px",
                              },
                            }}
                          >
                            <Grid>
                              <Button
                                variant="none"
                                onClick={handleClose}
                                style={{
                                  position: "absolute",
                                  top: "0.01em",
                                  right: "0.01em",
                                }}
                              >
                                <CancelTwoToneIcon
                                  style={{ color: "#a7e2f9" }}
                                />
                              </Button>
                              <Typography
                                sx={{
                                  fontWeight: "bold",
                                  color: "#081c54",
                                  marginTop: "1em",
                                  marginLeft: "0.5em",
                                  fontSize: "27px",
                                }}
                              >
                                {t("x_ray.task")}
                              </Typography>
                              <Typography style={{ margin: "1em" }}>
                                {t("x_ray.test")} : {item.xray_type_display}
                              </Typography>
                              <Typography style={{ margin: "1em" }}>
                                {t("x_ray.status")} : {XrayStatus[item.status]}
                              </Typography>
                              {item.status === 1 && (
                                <Box
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                  }}
                                >
                                  <MenuItem
                                    style={{
                                      ...buttonStyle,
                                      border: `2px solid ${getButtonColor(
                                        item.status
                                      )}`,
                                      color: getButtonColor(item.status),
                                    }}
                                    onClick={() => handleStatusChange(2)}
                                  >
                                    {t("x_ray.markAsCompleted")}
                                  </MenuItem>
                                  <MenuItem
                                    style={{
                                      ...buttonStyle,
                                      border: `2px solid ${getButtonColor(
                                        item.status
                                      )}`,
                                      color: getButtonColor(item.status),
                                    }}
                                    onClick={() => handleStatusChange(3)}
                                  >
                                    {t("x_ray.markAsCancelled")}
                                  </MenuItem>
                                </Box>
                              )}
                            </Grid>
                          </Menu>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </Grid>
        </Paper>
      )}
    </Grid>
  );
};

export default TestsToBeDone;
